import type { ToolStep } from './askTakiClient.js';

/** Un même résultat arrive parfois dans le flux puis dans la réponse finale. */
export function announceCompletedMutations(
  requestId: string,
  steps: readonly ToolStep[],
  seen: Set<string>,
  announce: (recordId: string | undefined) => void,
): void {
  for (const step of steps) {
    if (step.state !== 'done' || (step.kind !== 'create' && step.kind !== 'update')) continue;
    const key = `${requestId}:${step.id}`;
    if (seen.has(key)) continue;
    seen.add(key);
    announce(step.record?.id);
  }
}
